import { Asset } from '../../../../api/src/interfaces/shared';
import { AssetWithCalculatedStats } from '../../interfaces/interfaces';

export const addCalculatedStats = (asset: Asset): AssetWithCalculatedStats => ({
  ...asset,
  annualPercentReturn: getAnnualPercentReturn(asset),
  return: getReturn(asset),
  percentReturn: getPercentReturn(asset),
  totalValue: getTotalValue(asset)
});

const getReturn = (asset: Asset) =>
  asset.stockholding * asset.price - asset.totalPrice;

const getPercentReturn = (asset: Asset) =>
  (asset.price * asset.stockholding - asset.totalPrice) / asset.totalPrice;

const getAnnualPercentReturn = (asset: Asset) => {
  if (asset.transactionTimestamp === null) return 0;
  const percentChange = (asset.price * asset.stockholding) / asset.totalPrice;
  const msInOneDay = 1000 * 60 * 60 * 24;
  const epochNow = new Date().getTime();
  const daysSinceInvest = (epochNow - asset.transactionTimestamp) / msInOneDay;
  return Math.pow(percentChange, 1 / (daysSinceInvest / 365.25)) - 1;
};

const getTotalValue = (asset: Asset) => asset.stockholding * asset.price;
